import { GetProfilePictureResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to retrieve a user's profile picture using the api-model
 * @param userId User ID to fetch the profile picture for
 * @returns Promise with profile picture URL
 */
export const getProfilePictureApi = async (userId?: string): Promise<GetProfilePictureResponseContent> => {
  const request = createApiRequest<GetProfilePictureResponseContent>('post', '/getProfilePicture');
  // Only include userId in the request if it's provided
  if (userId) {
    return request({ userId });
  } else {
    // Send empty object when no userId is provided to get current user's profile
    return request({});
  }
};